import VideoSummaryPage from "@components/videos/video-summary-page";
import { PageVideoComp, ssrAllVideos, ssrVideo } from "@graphql/generated/page";
import { GetStaticPaths, GetStaticProps } from "next";
import { NextSeo } from "next-seo";
import { useRouter } from "next/router";
import { loadTranslation } from "@lib/utils";
import { useVideoPageLazyQuery } from "@graphql/generated/graphql";
import { useEffect } from "react";

// export const getStaticProps: GetStaticProps = async ({ params, locale }) => {
//   const translation = await loadTranslation(
//     locale,
//     process.env.NODE_ENV == "production"
//   );

//   const {
//     props: { data },
//   } = await ssrVideo.getServerPage(
//     {
//       variables: {
//         id: params?.id?.toString() || "",
//       },
//     },
//     null
//   );

//   if (!data.video) {
//     return {
//       redirect: {
//         destination: "/",
//         permanent: true,
//       },
//     };
//   }

//   return { props: { data, translation } };
// };

// export const getStaticPaths: GetStaticPaths = async () => {
//   const {
//     props: { data },
//   } = await ssrAllVideos.getServerPage({}, null);

//   const paths = data.allVideos?.map(({ id }) => ({ params: { id } })) || [];

//   return {
//     paths,
//     fallback: "blocking",
//   };
// };

const Video: PageVideoComp = () => {
  const router = useRouter();
  const [getVideo, { data, error, loading }] = useVideoPageLazyQuery();

  useEffect(() => {
    getVideo({ variables: { id: router.query.id as string } });
  }, [getVideo, router.query.id]);

  return (
    <>
      {data && data.video && (
        <NextSeo
          title={`${data.video.title} | Lumi News`}
          description={data.video.description}
        />
      )}
      <VideoSummaryPage data={data} loading={loading} error={error} />
    </>
  );
};

export default Video;
